import { motion } from "framer-motion";

export function BackgroundFx() {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none -z-10">
      <motion.div
        className="blob"
        style={{
          width: 520,
          height: 520,
          top: -200,
          left: -180,
          background: "#a78bfa",
          opacity: 0.16,
        }}
        animate={{ x: [0, 40, 0], y: [0, 25, 0] }}
        transition={{ duration: 30, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="blob"
        style={{
          width: 460,
          height: 460,
          bottom: -220,
          right: -160,
          background: "#38bdf8",
          opacity: 0.12,
        }}
        animate={{ x: [0, -30, 0], y: [0, -20, 0] }}
        transition={{ duration: 36, repeat: Infinity, ease: "easeInOut" }}
      />
    </div>
  );
}
